import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { ColorScheme } from '../models';

import { ConfigurationService } from './configuration.service';

@Injectable({
    providedIn: 'root',
})
export class ColorSchemeService {
    private colorScheme: ColorScheme = { cards: '#444655', messages: '#0070cc' };
    private colorSchemeSubject: Subject<ColorScheme> = new BehaviorSubject<ColorScheme>(this.colorScheme);

    constructor(private configurationService: ConfigurationService) {
        this.configurationService.getTenantConfiguration('colorScheme').subscribe((colorScheme: ColorScheme) => {
            if (colorScheme && colorScheme.cards && colorScheme.messages) {
                this.colorSchemeSubject.next(colorScheme);
            }
        });
    }

    colorSchemeChanges(): Observable<ColorScheme> {
        return this.colorSchemeSubject.asObservable();
    }
}
